exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".QuestionsStudent{padding:0 20px}.QuestionsStudent .input-sessions{display:flex}.QuestionsStudent .question-student{display:flex;flex-direction:column;overflow:hidden;overflow-y:auto;height:calc(100vh - 363px);padding:20px}.QuestionsStudent .question-student .item-message{background:#dfeaf3;border:1px solid #00adff;padding:10px;font-size:18px;position:relative}.QuestionsStudent .question-student .item-message .slide-index{position:absolute;background:#00adff;color:#fff;font-size:12px;padding:2px 5px;top:-8px;left:-8px;z-index:999}.QuestionsStudent .question-student .item-message+.item-message{margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/Presentation/components/Slide/components/QuestionsStudent/style.scss
// module id = 5098
// module chunks = 0